import React from "react";
import { Table } from "react-bootstrap";

import { useRatingsContext } from "../contexts/Ratings";

const IndividualRatings = (): React.JSX.Element => {
    const { ratings } = useRatingsContext();

    return (
        <Table
            className="currentYearIndividualRatings"
            striped
            data-testid="currentYearIndividualRatings"
        >
            <thead>
                <tr>
                    <th>Umpire</th>
                    <th>Head Coaching</th>
                    <th>Asst. Coaching</th>
                    <th>Spectators</th>
                    <th>Overall</th>
                </tr>
            </thead>
            <tbody>
                {ratings.map(r => (
                    <tr key={r.id}>
                        <td>{r.ratedBy.name}</td>
                        <td>{r.ratings.headCoach}</td>
                        <td>{r.ratings.asstCoach}</td>
                        <td>{r.ratings.spectators}</td>
                        <td>{r.ratings.overall}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default IndividualRatings;
